<template>
    <div class="mt-4 mb-5">
        <div class="" v-if="loading">
            <!-- Show the loader when async operation is going on -->
            <div class="loader"></div>
        </div>
        <div class="row" v-if="!loading">
            <div class="col-12">
                <div class="mb-2">
                    <span class="mr-3 align-middle col-mb heading-text">WordPress Admin User</span>
                    <span class="badge badge-success" v-if="envType === 'live'">LIVE</span>
                    <span class="badge bg-violate" v-else>Staging</span>
                </div>
            </div>
            <div class="col-sm-12">
                <button class="btn btn-sm btn-success pull-right" v-on:click="openModal('newAdmin')">Add new Admin</button>
            </div>
            <div class="col-sm-12" >
                <div class="table-responsive">
                    <table class="table table-striped ">
                        <thead class="text-primary">
                        <tr>
                            <th class="text-center">Username</th>
                            <th class="text-center">Password</th>
                            <th class="text-center">Email</th>
                            <th class="text-center">Created On</th>
                            <th class="text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(user, index) in admin_users" :key="index">
                            <td class="text-center "><small><b>{{user.user_login}}</b></small></td>
                            <td class="text-center">
                                <span class="btn btn-sm btn-primary" v-on:click="openModal('password',user.ID)"><i class="fa fa-pencil"></i></span>
                            </td>
                            <td class="text-center">
                                <span class="mr-1">{{user.user_email}}</span>
                                <span class="btn btn-sm btn-primary " v-on:click="openModal('email',user.ID)"><i class="fa fa-pencil"></i></span>
                            </td>
                            <td class="text-center">
                                <span class="">{{user.user_registered}}</span>
                            </td>
                            <td class="text-center">
                                <span class=""><span class="btn btn-sm btn-danger" v-on:click="openModal('delete',index)"><i class="fa fa-trash"></i></span></span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-sm-12" v-if="!loading && !admin_users.length>0">
                <span class="text-primary">No admin user exists for this domain!</span>
            </div>
        </div>

        <div class="stepModal position-relative">
            <div class="modal fade" id="changeModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="twoFAStepModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="twoFAStepModalHeader">{{(section === 'newAdmin')?'Add New Admin':(section === 'delete')?'Delete Admin':'Update Account'}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <section v-if="section === 'email'">
                                <form v-on:submit.prevent="changeEmail()">
                                    <div class="row">
                                        <div class="col-md-12 ">
                                            <div class="form-group">
                                                <label>Enter new email here.</label>
                                                <input type="email" class="form-control" required v-model="newEmail" placeholder="Enter Email Here..." />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="loader pull-right" v-if="btn_email_disabled" style="width: 40px;height: 40px; margin: 0.8rem 0 !important;"></div>
                                            <button type="submit" class="btn btn-primary btn-sm pull-right" v-if="!btn_email_disabled" :disabled="newEmail.length<=0||btn_email_disabled" >
                                                Update
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </section>
                            <section v-if="section === 'password'">
                                <div class="row">
                                    <div class="col-md-12 ">
                                        <div class="form-group">
                                            <div class="input-group input-group-md">
                                                <input type="text" class="form-control" v-model="newPassword" placeholder="Enter Password...">
                                                <div class="input-group-append">
                                                    <button data-toggle="tooltip" data-placement="top" title="Generate Secure Password" @click="generatePassword()" class="btn btn-primary btn-sm" style="margin: 0"><i class="fa fa-pencil"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 ">
                                        <div class="form-group">
                                            <input type="text" class="form-control" v-model="confirmPassword" placeholder="Confirm Password..." />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="loader pull-right" v-if="btn_password_disabled" style="width: 40px;height: 40px; margin: 0.8rem 0 !important;"></div>
                                        <button class="btn btn-primary btn-sm pull-right" v-if="!btn_password_disabled" :disabled="btn_password_disabled" @click="changePassword()">
                                            Update
                                        </button>
                                    </div>
                                </div>
                            </section>
                            <section v-if="section === 'newAdmin'">
                                <form v-on:submit.prevent="addNewAdmin()">
                                    <div class="row">
                                        <div class="col-md-12 ">
                                            <div class="form-group">
                                                <label>Username</label>
                                                <input type="text" required class="form-control" v-model="newAdmin.username" placeholder="Enter username here..." />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 ">
                                            <div class="form-group">
                                                <label>Email</label>
                                                <input type="email" required class="form-control" v-model="newAdmin.email" placeholder="Enter email here..." />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="loader pull-right" v-if="btn_new_admin_disabled" style="width: 40px;height: 40px; margin: 0.8rem 0 !important;"></div>
                                            <button class="btn btn-primary btn-sm pull-right" v-if="!btn_new_admin_disabled" :disabled="btn_new_admin_disabled">
                                                Create
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </section>
                            <section v-if="section === 'delete'">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label>Which admin would you like to reassign posts?  </label>
                                        <select class=" form-control" v-model="reassignPostID">
                                            <option v-for="(user, index) in admin_users" :class="(user_id === user.ID)?'hide':''" :disabled="(user_id === user.ID)" :key="index" :value="user.ID">{{ user.user_login }}</option>
                                            <option value="none">None</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="loader pull-right" v-if="btn_delete_disabled" style="width: 40px;height: 40px; margin: 0.8rem 0 !important;"></div>
                                        <button class="btn btn-primary btn-sm pull-right" v-if="!btn_delete_disabled" :disabled="btn_delete_disabled" v-on:click="deleteAdmin">
                                            Continue
                                        </button>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import swal from 'sweetalert2';
    export default {
        name: "AdminUsers",
        props: {
            account: {
                type: Object,
                required: true
            },
            envType: {
                type: String,
                required: true
            },
            fromCollaborator: {
                type: Boolean,
                required: false
            },
            supervisor: {
                type: Object,
                required: false
            }
        },
        data(){
            return{
                btn_new_admin_disabled:false,
                btn_delete_disabled:false,
                admin_users:[],
                newAdmin:{
                    username:'',
                    email:''
                },
                reassignPostID:'',
                loading:true,
                section:'',
                newEmail:'',
                newPassword: '',
                confirmPassword:'',
                user_id:'',
                btn_password_disabled:false,
                btn_email_disabled:false,
                selectedMainDomain:'',
                deleteAdminUserName:''
            }
        },
        computed:{
            user() {
                return this.$store.getters.user;
            }
        },
        created(){
            if(this.envType === 'live'){
                this.selectedMainDomain = this.account.domain;
            }else{
                this.selectedMainDomain = this.account.staging.domain;
            }
            this.getAdminUsers();
        },
        watch: {
            envType(val) {
                if(val === 'live'){
                    this.selectedMainDomain = this.account.domain;
                }else{
                    this.selectedMainDomain = this.account.staging.domain;
                }
                this.getAdminUsers();
            },
            account(){
                if(this.envType === 'live'){
                    this.selectedMainDomain = this.account.domain;
                }else{
                    this.selectedMainDomain = this.account.staging.domain;
                }
                this.getAdminUsers();
            }
        },
        methods:{
            deleteAdmin(){
                if(this.reassignPostID!==''){
                    this.btn_delete_disabled = true;
                    this.$http.post('admin-user/delete',{
                        grant_type: "token",
                        ip: this.account.ftp.host,
                        domain:this.selectedMainDomain,
                        username:this.deleteAdminUserName,
                        reassignId:this.reassignPostID,
                    }).then(resp=>{
                        console.log(resp.data);
                        this.getAdminUsers();
                        $("#changeModal").modal('hide');
                        this.reassignPostID = '';
                        this.deleteAdminUserName = '';
                        this.btn_delete_disabled = false;
                        swal('Success!', resp.data.msg, 'success');
                    }).catch(()=>{
                        this.btn_delete_disabled = false;
                        swal('Error!', 'Something went wrong!', 'error');
                    });
                }else{
                    swal('Error!', 'Please select any option!', 'error');
                }
            },
            addNewAdmin(){
                if(this.newAdmin.email!==''&& this.newAdmin.username!==''){
                    this.btn_new_admin_disabled = true;
                    this.$http.post('admin-user/add',{
                        grant_type: "token",
                        ip: this.account.ftp.host,
                        domain:this.selectedMainDomain,
                        username:this.newAdmin.username,
                        email:this.newAdmin.email,
                    }).then(resp=>{
                        console.log(resp.data);
                        this.getAdminUsers();
                        $("#changeModal").modal('hide');
                        this.btn_new_admin_disabled = false;
                        this.newAdmin.email='';
                        this.newAdmin.username='';
                        swal('Success!', resp.data.msg, 'success');
                    }).catch((e)=>{
                        this.btn_new_admin_disabled = false;
                        swal('Error!',e.response.data , 'error');
                    });
                }else{
                    swal('Error!', 'All fields are required!', 'error');
                }
            },
            async getAdminUsers(){
                if(this.selectedMainDomain){
                    this.loading = true;
                    const response = await this.$http.post('admin-user',{
                        grant_type: "token",
                        ip: this.account.ftp.host,
                        domain:this.selectedMainDomain,
                        email:(!this.fromCollaborator) ? this.user.email : this.supervisor.supervisorEmail,
                    });
                    this.admin_users = response.data.adminUsers;
                    this.loading = false;
                }else{
                    this.admin_users = [];
                }
            },
            openModal(section,id){
                this.section = section;
                if(section === 'delete'){
                    this.deleteAdminUserName = this.admin_users[id].user_login;
                    this.user_id =this.admin_users[id].ID;
                }else{
                    this.user_id = id;
                }
                this.newPassword='';
                this.confirmPassword='';
                this.newEmail='';
                this.newAdmin.email='';
                this.newAdmin.username='';
                $('#changeModal').modal('show');
                $('.modal-backdrop').removeClass("modal-backdrop");
            },
            changePassword(){
                if(this.newPassword!=='' && this.confirmPassword!==''){
                    if(this.newPassword ===this.confirmPassword){
                        this.btn_password_disabled = true;
                        this.$http.post('admin-user/change-password',{
                            grant_type: "token",
                            ip: this.account.ftp.host,
                            domain:this.selectedMainDomain,
                            password:this.newPassword,
                            id:this.user_id,
                        }).then(resp=>{
                            console.log(resp.data);
                            $("#changeModal").modal('hide');
                            this.btn_password_disabled = false;
                            this.newPassword='';
                            this.confirmPassword='';
                            swal('Success!', resp.data.msg, 'success');
                        }).catch(()=>{
                            this.btn_password_disabled = false;
                            swal('Error!', 'Something went wrong!', 'error');
                        });
                    }else{
                        swal('Error!', 'Password didn\'t match!', 'error');
                    }
                }else{
                    swal('Error!', 'Both fields are required!', 'error');
                }

            },
            changeEmail(){
                if(this.newEmail!==''){
                    this.btn_email_disabled = true;
                    this.$http.post('admin-user/change-email',{
                        grant_type: "token",
                        ip: this.account.ftp.host,
                        domain:this.selectedMainDomain,
                        email:this.newEmail,
                        id:this.user_id,
                    }).then(resp=>{
                        console.log(resp.data);
                        this.getAdminUsers();
                        $("#changeModal").modal('hide');
                        this.newEmail='';
                        this.btn_email_disabled = false;
                        swal('Success!', resp.data.msg, 'success');
                    }).catch(()=>{
                        this.btn_email_disabled = false;
                        swal('Error!', 'Something went wrong!', 'error');
                    });
                }else{
                    swal('Error!', 'Email is required!', 'error');
                }

            },
            generatePassword() {
                const characters = 'a-z,A-Z,0-9,#';
                const size = 12;
                let charactersArray = characters.split(',');
                let CharacterSet = '';
                let password = '';

                if( charactersArray.indexOf('a-z') >= 0) {
                    CharacterSet += 'abcdefghijklmnopqrstuvwxyz';
                }
                if( charactersArray.indexOf('A-Z') >= 0) {
                    CharacterSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
                }
                if( charactersArray.indexOf('0-9') >= 0) {
                    CharacterSet += '0123456789';
                }
                if( charactersArray.indexOf('#') >= 0) {
                    CharacterSet += '![]{}()%&*$#^<>~@|';
                }

                for(let i=0; i < size; i++) {
                    password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
                }
                this.newPassword = password;
            },
        }
    }
</script>

<style scoped>
.hide{
    display: none !important;
}
</style>
